export const roomTypes = [
    {
        // 1. Двухместный номер «твин/дабл» «Улучшенный» - БЕЗ ИЗМЕНЕНИЙ
        id: '1 местный однокомнатный номер "Эконом"',
        category: 'НОМЕРА САНАТОРИЯ',
        title: '1 местный однокомнатный номер "Эконом"',
        description: 'Компактный одноместный номер, оснащенный всем необходимым для экономичного и комфортного проживания. Идеально подходит для индивидуальных путешественников.',
        images: [
            '/Assets/Rooms/1/01.png',
        ],
        price: 'от 6 200 руб/сутки',
    },
    {
        // 2. Двухместный номер «дабл» «Комфорт» - БЕЗ ИЗМЕНЕНИЙ
        id: '1 местный 2-х комнатный улучшенный номер',
        category: 'НОМЕРА САНАТОРИЯ',
        title: '1 местный 2-х комнатный улучшенный номер',
        description: 'Просторный двухкомнатный номер для одного гостя с отдельной зоной отдыха, обеспечивающий повышенный уровень комфорта и приватности.',
        images: [
            '/Assets/Rooms/2/02.png',
        ],
        price: 'от 6 700 руб/сутки',
    },
    {
        // 3. Двухместный номер «ДАБЛ» "Стандарт" - БЕЗ ИЗМЕНЕНИЙ
        id: '1 местный однокомнатный номер Стандарт',
        category: 'НОМЕРА САНАТОРИЯ',
        title: '1 местный однокомнатный номер Стандарт',
        description: 'Классический одноместный номер со стандартным набором удобств, предлагающий уютное пространство для отдыха после процедур.',
        images: [
            '/Assets/Rooms/3/03.png',
        ],
        price: 'от 6 500 руб/сутки',
    },
    {
        // 4. Двухместный двухкомнатный номер «дабл» «Премиум» - ВАРИАНТ 1
        id: '2-х местный однокомнатный номер',
        category: 'НОМЕРА САНАТОРИЯ',
        title: '2-х местный однокомнатный номер',
        description: 'Уютный однокомнатный номер для двоих, оформленный в классическом стиле. В номере есть все для комфортного отдыха и оздоровления.',
        images: [
            '/Assets/Rooms/4/04.png', // Замените на реальные фото для Дизайна 1
        ],
        price: 'от 5 600 руб/сутки',
    },
    {
        // 4. Двухместный двухкомнатный номер «дабл» «Премиум» - ВАРИАНТ 2
        id: '2-х комнатный 2-х местный номер',
        category: 'НОМЕРА САНАТОРИЯ',
        title: '2-х комнатный 2-х местный номер',
        description: 'Элегантный двухкомнатный номер для двоих, выполненный в современном дизайне. Идеален для длительного пребывания с максимальным комфортом и приватностью.',
        images: [
            '/Assets/Rooms/5/05.png', // Замените на реальные фото для Дизайна 2
        ],
        price: 'от 6 000 руб/сутки',
    },
    {
        // 4. Двухместный двухкомнатный номер «дабл» «Премиум» - ВАРИАНТ 3
        id: 'Люкс (5 местный 4-х комнатный номер)',
        category: 'НОМЕРА САНАТОРИЯ',
        title: 'Люкс (5 местный 4-х комнатный номер)',
        description: 'Роскошный четырехкомнатный Люкс для большой семьи или компании до пяти человек. Просторные спальни и общие зоны выполнены в светлых тонах, обеспечивая исключительный комфорт и уединение.',
        images: [
            '/Assets/Rooms/6/06.png',
        ],
        price: 'от 6 200 руб/сутки',
    },
];